import { render } from "./setDiscountPartners.vue?vue&type=template&id=5c1d36e2&scoped=true"
import script from "./setDiscountPartners.vue?vue&type=script&lang=js"
export * from "./setDiscountPartners.vue?vue&type=script&lang=js"

import "./setDiscountPartners.vue?vue&type=style&index=0&id=5c1d36e2&lang=scss"
import "./setDiscountPartners.vue?vue&type=style&index=1&id=5c1d36e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1d36e2"]])

export default __exports__